
export class PagedList<T> {
  static empty: PagedList<any> = new PagedList<any>(0, 0, 0, []);
  page: number;
  pageSize: number;
  totalItemCount: number;
  items: T[];

  constructor(page: number, pageSize: number, totalItemCount: number, items: T[]) {
    this.page = page;
    this.pageSize = pageSize;
    this.totalItemCount = totalItemCount;
    this.items = items;
  }
}